// @와 *을 필터링 하는 함수

export const filterMarkdown = (str: string) => {
    if (!str) return '';
    return str.replace(/[@*]/g, "");
};
